import MyAccountComponent from "./MyAccount.container";

export default MyAccountComponent;
